import useAuth from './useAuth';
import config from '../common/Config';
import { useNavigate } from 'react-router-dom';

const useLogout = () => {
	
	const { setAuth } 	= useAuth()
	const navigate		= useNavigate()
	

	const logout = async () => {
		fetch(config.apiUrl +'/logout', {credentials : 'include'})
		setAuth({})

		navigate('/login')
		
		return
	}

	return logout
}

export default useLogout